import React, {useCallback, useEffect, useState} from "react";
import {Button, TextField} from "@mui/material";
import debounce from 'lodash.debounce';
import FunctionsData from "../Functions/FunctionsData";
import DisplayManualForm from "./DisplayManualForm";

export default function LandingAutoComplete({row,close,text, setGooglePlace}) {

    const ph = (text || "Type your address");
    const [options,setOptions] = useState([]);
    const [value, setValue] = useState(row.formatted_address || '');
    const [valueP, setValueP] = useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [isSelected, setIsSelected] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(false);

    // console.log(selectedRow);

    const [showManualForm, setShowManualForm] = React.useState(false);

    useEffect(() => {
        //console.log('value',value);
        if(value !== '') {
            setIsSelected(true);
            setSelectedRow(row);
        }
    }, [])

    const path = '/api/search/location';

    function selectPlace(e, row) {
        e.preventDefault();
        setIsSelected(true);
        // setValue(row.formatted_address);

        //console.log(row);
        if(close > 0) {
            setSelectedRow(row);
            setIsLoading(true);
            setGooglePlace(row);
        }else{
            setSelectedRow(row);
            setGooglePlace(row);
        }

        try {
            window.gtag('event', 'action', {
                category: 'User',
                action: 'Selected address from dropdown',
                postcode:row.POSTCODE,
                city:row.TOWN_CITY_MAILTOWN
            });
        }catch(e) {
            //
        }
    }

    function getValueCLeanForSearch(value) {
        return value.replace(/ /g, '').toLowerCase() ;
    }

    async function getList (e) {

        //console.log(e.target.value);
        setIsLoading(false);
        setValueP(e.target.value);

        if(e.target.value.length > 2) {
            const tkn = await FunctionsData.getCSRFToken();
            await fetch(FunctionsData.getApiUrl(path), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'token': sessionStorage.sTkn,
                    'X-CSRF-Token':tkn.csrf
                },
                body:JSON.stringify({'s':getValueCLeanForSearch(e.target.value)})
            })
                .then((res) => {
                    if (res.status === 401) {
                        sessionStorage.clear();
                        window.location.href = '/';
                    }
                    return res.json()
                })
                .then((d) => {
                    setIsLoading(false);
                    setOptions(d.data);
                });
        }

    }

    const debouncedChangeHandler = useCallback(
        debounce(getList, 300)
    , []);

    function loadManualForm(e) {
        e.preventDefault();
        setShowManualForm(true);

        try {
            window.gtag('event', 'action', {
                category: 'User',
                action: 'Clicked enter address manually'
            });
        }catch(e) {
            //
        }
    }

    const ShowList = () => {
        if(!options) return null;
        if(showManualForm === true) return <DisplayManualForm showManualForm={showManualForm}
                                                              setShowManualForm={setShowManualForm}
                                                              selectPlace={selectPlace}
        />
        if(isLoading === true) return (<div>Loading ...</div>);
        if (value.length ===0 && options.length === 0 && isLoading === true) return (<div>Loading ...</div>);
        if (value.length > 0 && options.length === 0 && isLoading === true) return (<div>Loading ...</div>);

        if (value.length > 0 && value.length < 4 && options.length === 0 && isLoading === false) return (
            <div>
                Please enter at least 3 characters ...
            </div>
            )
        if (value.length > 0 && options.length === 0 && isLoading === false) return (
            <div>
                No results found. Please try again or add your address <a href={"#"} onClick={loadManualForm}>manually</a>.
            </div>
        );

        return (
            <div>
                {options.map((d) => {
                   return (
                       <div key={(Date.now().toFixed(5)) + Math.random()} style={{width:'calc(100% - 20px)',textAlign:'left', border:'1px solid rgba(0,0,0,0.1', marginTop:10, padding:10}}>
                           <button onClick={(e) => selectPlace(e,d)} style={{padding:5, marginRight:10}}>Select</button>{d.address}
                       </div>
                   )
                })}
            </div>
        )
    }

    const ShowSelectedRow = () => {
        if(value === '') return null;
        return (
            <span></span>
        )
    }

    if(isSelected === true) return (
        <div className={"address-confirmed"}>
            <h3>Your address:</h3>
            {selectedRow.address} <a href="" onClick={(e) =>{
                e.preventDefault();
                setOptions([]);
                setIsSelected(false);
                }}>Change</a>
        </div>

    )

    if(showManualForm === true) return (
        <ShowList />
    );
    return (
        <div>
            <TextField id="outlined-basic"
                       label={ph}
                       placeholder={"# street, town, postcode"}
                       variant="outlined" sx={{width:'100%'}}
                       onChange={(e) => {
                           setValue(e.target.value);
                           debouncedChangeHandler(e)
                       }}
                       value={value}
            />
            <ShowSelectedRow />
            <ShowList />
        </div>
    )

}
